import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Center,
  FileInput,
  Heading,
  Input,
  Loader,
  MyModal,
  MyPopup,
} from "../../../utils/layoutUtils";
import { FiEdit, FiPlus, FiTrash } from "react-icons/fi";
import myContext from "../../../context/data/myContext";
import Table from "../../../components/Table";
import { addEdit_events, delete_Events } from "../../../utils/apis";
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { IoEyeOutline } from "react-icons/io5";
import { IoMdDownload } from "react-icons/io";
import { downloadFile } from "../../../utils/Utils";

const Events = () => {
  const context = useContext(myContext);
  const { events_list, loading, getEventsList } = context;
  const [open1, setOpen1] = useState(false);
  const [detail, setdetail] = useState({});
  const [loading1, setLoading1] = useState(false);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);

  const navigate = useNavigate();

  const onDelete = async () => {
    const res = await delete_Events(detail.ID, setLoading1);
    if (res.success) {
      setOpen1(false);
      getEventsList();
      toast.success(res.message);
    } else {
      toast.error(res.message);
    }
  };
  const onAdd = async () => {
    if (
      !detail.Name ||
      !detail.Event_Date ||
      !detail.Event_Time ||
      !detail.Venue ||
      (!edit && !detail.img?.name)
    ) {
      setdetail({
        ...detail,
        NameMess: !detail.Name ? "Name is required" : "",
        Event_DateMess: !detail.Event_Date ? "Event Date is required" : "",
        Event_TimeMess: !detail.Event_Time ? "Event Time is required" : "",
        VenueMess: !detail.Venue ? "Event Venue is required" : "",
        imgMess: !edit && !detail.img?.name ? "Event Banner is required" : "",
      });
      return;
    }
    const formdata = new FormData();

    edit
      ? formdata.append("action", "update")
      : formdata.append("action", "create");
    edit && formdata.append("id", detail.ID);
    formdata.append("Name", detail.Name);
    formdata.append("Event_Date", detail.Event_Date);
    formdata.append("Event_Time", detail.Event_Time);
    formdata.append("Venue", detail.Venue);
    formdata.append("image", detail.img);
    const res = await addEdit_events(formdata, setLoading1);
    if (res?.success) {
      setOpen(false);
      getEventsList();
      toast.success(res?.message);
    } else {
      toast.error(res?.message);
    }
  };

  return (
    <div className="w-full block">
      <div className="flex justify-between items-center">
        <Heading title={"Events"} />
        <Button
          title={"Add"}
          icon={<FiPlus size={20} />}
          onClick={() => {
            setdetail({});
            setEdit(false);
            setOpen(true);
          }}
        />
      </div>
      {loading ? (
        <Loader />
      ) : (
        <Table
          searchValue={search}
          onSearchChange={(v) => {
            setSearch(v.target.value);
          }}
          noData={events_list}
          headData={[
            "S.No.",
            "Name",
            "Venue",
            "Event Date",
            "Event Time",
            "Banner",
            "Actions",
          ]}
        >
          {events_list
            ?.filter((item) => {
              return (
                item.Name.toLowerCase().includes(search.toLowerCase()) ||
                item.Venue.toLowerCase().includes(search.toLowerCase())
              );
            })
            .map((item, index) => (
              <tr
                className="text-center items-center justify-center"
                key={index}
              >
                <td className="whitespace-nowrap">{index + 1}</td>
                <td className="whitespace-nowrap">{item.Name}</td>
                <td className="whitespace-nowrap">{item.Venue}</td>
                <td className="whitespace-nowrap">{item.Event_Date}</td>
                <td className="whitespace-nowrap">
                  {moment(item.Event_Time,"hh:mm A").format("hh:mm A")}
                </td>
                <td className="p-2 justify-center flex">
                  <img
                    src={item.Image}
                    className="h-[150px] w-[150px] object-contain"
                  />
                </td>

                <td className="whitespace-nowrap ">
                  <div className="flex gap-2 justify-center">
                    {item?.qrcode && (
                      <IoMdDownload
                        onClick={() => {
                          downloadFile(item?.qrcode);
                        }}
                        size={20}
                        className="cursor-pointer"
                      />
                    )}

                    <IoEyeOutline
                      //  color="#2b3478"
                      onClick={() => {
                        navigate("/events_details", { state: item });
                      }}
                      size={20}
                      className="cursor-pointer"
                    />

                    <FiEdit
                      color="#2b3478"
                      size={20}
                      className="cursor-pointer"
                      onClick={() => {
                        setdetail(item);
                        setEdit(true);
                        setOpen(true);
                      }}
                    />
                    <FiTrash
                      color="#d1262b"
                      size={20}
                      className="cursor-pointer"
                      onClick={() => {
                        setdetail(item);
                        setOpen1(true);
                      }}
                    />
                  </div>
                </td>
              </tr>
            ))}
        </Table>
      )}
      <MyModal
        isOpen={open}
        setIsOpen={setOpen}
        title={edit ? "Edit Event" : "Add Event"}
      >
        <div className="p-5 w-full">
          <div className="flex w-full gap-4">
            <Input
              label={"Event Name"}
              placeholder={"Event Name"}
              value={detail.Name}
              onChange={(v) => {
                setdetail({ ...detail, Name: v.target.value, NameMess: "" });
              }}
              error={detail.NameMess}
            />
            <Input
              label={"Venue"}
              placeholder={"Venue"}
              value={detail.Venue}
              onChange={(v) => {
                setdetail({ ...detail, Venue: v.target.value, VenueMess: "" });
              }}
              error={detail.VenueMess}
            />
          </div>
          <div className="flex w-full gap-4">
            <Input
              label={"Date"}
              placeholder={"Date"}
              type="date"
              value={detail.Event_Date}
              onChange={(v) => {
                setdetail({
                  ...detail,
                  Event_Date: v.target.value,
                  Event_DateMess: "",
                });
              }}
              error={detail.Event_DateMess}
            />
            {/* <Input
              label={"Time"}
              placeholder={"Time"}
              type="time"
              value={moment(detail.Event_Time, "hh:mm").format("hh:mm:ss")}
              onChange={(v) => {
                setdetail({
                  ...detail,
                  Event_Time: v.target.value,
                  Event_TimeMess: "",
                });
              }}
              error={detail.Event_TimeMess}
            /> */}
            <Input
              label={"Time"}
              placeholder={moment(detail.Event_Time, "hh:mm A").format(
                "hh:mm A"
              )}
              type="time"
              // value={moment(detail.Event_Time, "hh:mm A").format("hh:mm A")}
              onChange={(v) => {
                setdetail({
                  ...detail,
                  Event_Time: v.target.value,
                  Event_TimeMess: "",
                });
              }}
              error={detail.Event_TimeMess}
            />
          </div>

          <div className="flex w-full gap-4">
            <FileInput
              doctype={".png,.jpg,.jpeg"}
              label={"Banner"}
              placeholder={"Banner"}
              fileName={detail.img?.name}
              onChange={(v) => {
                setdetail({
                  ...detail,
                  img: v.target.files[0],
                  imgMess: "",
                });
              }}
              error={detail.imgMess}
            />
            <div className="flex-1" />
          </div>

          <Center>
            <Button
              title={edit ? "Update" : "Submit"}
              onClick={onAdd}
              loading={loading1}
            />
          </Center>
        </div>
      </MyModal>
      <MyPopup
        isOpen={open1}
        setIsOpen={setOpen1}
        title={"Delete"}
        message={"Are you sure? You want to delete data"}
        bname={"Delete"}
        onClick={() => onDelete()}
        loading={loading1}
      ></MyPopup>
    </div>
  );
};

export default Events;
